import { render, staticRenderFns } from "./clientEditModal.vue?vue&type=template&id=1013f41b&scoped=true"
import script from "./clientEditModal.vue?vue&type=script&lang=js"
export * from "./clientEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1013f41b",
  null
  
)

export default component.exports